import { NgModule } from '@angular/core';
import { SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { ShopWorkingTimeComponent } from './shop-working-time.component';

@NgModule({
  declarations: [ShopWorkingTimeComponent],
  imports: [SdvorIconComponent],
  exports: [ShopWorkingTimeComponent],
})
export class ShopWorkingTimeModule {}
